import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const LoaderGrid = styled(Grid)`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 4rem auto;
`;
